module.exports = __webpack_public_path__ + "static/media/angry-mad-yelling-emoji-emoticon-svgrepo-com.9d0b24da.svg";